export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/array.js
// module id = 893
// module chunks = 3